// extracted by mini-css-extract-plugin
export default {"field":"YLOOF9","submitButton":"GedczH","success":"Xl00iu","error":"dhJOMz","slider":"eLC6M0","loginLink":"rLh29V","form":"pvmpnz"};